import type { ReactNode } from 'react';

import { faClose } from '@awesome.me/kit-8a9525ab71/icons/classic/light';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { TOAST_VARIANTS } from './types';

import type { ToastVariant } from './types';

import { cn } from '@/lib/utils';

interface ToastProps {
  message: ReactNode;
  variant: ToastVariant;
  onClose?: () => void;
}

export const Toast = ({ message, variant, onClose }: ToastProps) => {
  const { color, icon, styles } = TOAST_VARIANTS[variant];

  return (
    <div
      className={cn(
        `flex w-full items-start gap-12 rounded-lg border p-16 text-subheader-brand-regular`,
        styles,
        color,
      )}
      data-testid={`toast-${variant}`}
      role="alert"
    >
      <FontAwesomeIcon
        className={cn(color, 'shrink-0')}
        icon={icon}
        size="lg"
      />

      <span className="flex-1">{message}</span>

      {onClose && (
        <button
          className="size-24 shrink-0 cursor-pointer"
          data-testid="toast-close-button"
          type="button"
          onClick={onClose}
        >
          <FontAwesomeIcon className={cn(color, 'size-16')} icon={faClose} />
        </button>
      )}
    </div>
  );
};
